var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTronLogoWhitePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 259.5",
    style: {
      enableBackground: "new 0 0 1080 259.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_2_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.7,183.6c-3,1.8-6.2,3.1-9.8,4.1c-3.6,0.9-7.2,1.4-10.8,1.4c-7.4,0-13.4-2.1-18-6.3 c-4.6-4.2-6.9-10.3-6.9-18.2v-36.8h-11.1v-15.6h11.1V90.3h22.6v21.8h21.5v15.8h-21.5v32.8c0,6.1,2.4,9.2,7.2,9.2c3.3,0,7-1,11.1-3 L326.7,183.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370,111.7c4.4-2.6,9.6-3.9,15.5-4v21.4c-0.8-0.1-2-0.1-3.5-0.1c-7,0-12.5,1.9-16.6,5.7 c-4.1,3.8-6.1,8.8-6.1,15.1V188h-22.7v-79.4h22.7v14.3C361.9,118,365.5,114.2,370,111.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.9,112.9c6.4,3.3,11.4,8.1,15,14.2c3.5,6.1,5.3,13.2,5.3,21.3c0,8-1.8,15-5.3,21.2 c-3.5,6.2-8.5,10.9-15,14.3c-6.4,3.4-13.9,5.1-22.2,5.1c-8.5,0-15.9-1.7-22.4-5.1c-6.4-3.4-11.4-8.2-15-14.3 c-3.5-6.1-5.3-13.2-5.3-21.2c0-8.1,1.8-15.2,5.3-21.3c3.5-6.1,8.5-10.8,15-14.2c6.4-3.3,13.9-5,22.4-5 C438.1,107.8,445.5,109.5,451.9,112.9z M415.3,132.8c-3.7,4-5.5,9.3-5.5,15.8c0,6.5,1.8,11.8,5.5,15.8c3.7,4,8.5,6.1,14.4,6.1 c5.8,0,10.6-2,14.2-6.1c3.7-4,5.5-9.3,5.5-15.8c0-6.5-1.8-11.8-5.5-15.8c-3.7-4-8.4-6.1-14.2-6.1C423.8,126.7,419,128.7,415.3,132.8 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M554.6,116c5.3,5.5,7.9,12.9,7.9,22.1V188h-22.7v-43.2c0-5-1.4-9-4.2-11.9c-2.8-2.9-6.6-4.4-11.4-4.4 c-5.6,0.1-10,2-13.3,5.8c-3.2,3.8-4.9,8.6-4.9,14.5V188h-22.7v-79.4H506v13.9c5.5-9.6,14.7-14.6,27.5-14.8 C542.3,107.7,549.4,110.4,554.6,116z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 561.8701,
    y1: 171.9705,
    x2: 968.5934,
    y2: 276.9067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.331947e-7,
    style: {
      stopColor: "#1B0C5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F0770"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.7,169.1c2.1,2.2,3.2,5,3.2,8.4c0,3.4-1.1,6.3-3.2,8.5c-2.1,2.2-4.8,3.3-8.2,3.3c-3.2,0-6-1.1-8.1-3.4 c-2.2-2.3-3.2-5.1-3.2-8.4c0-3.4,1.1-6.2,3.2-8.4c2.2-2.2,4.9-3.2,8.1-3.2C586.9,165.8,589.6,166.9,591.7,169.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M674.5,118.4c5.3,5.4,7.9,12.7,7.9,22.1V188h-10v-45.2c0-7.3-2-13-6.1-17.1c-4-4.1-9.6-6.2-16.8-6.2 c-8.6,0.1-15.3,2.9-20.1,8.5c-4.9,5.6-7.3,12.9-7.3,22.1V188h-9.9V90.3h9.9v38.7c5.2-12.2,15.4-18.4,30.7-18.6 C662,110.3,669.2,113,674.5,118.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M757.4,121.8c6.3,7.6,9.2,17.9,8.7,30.8h-64.5c0.7,8.3,3.7,14.9,9.2,20c5.4,5.1,12.1,7.6,20.1,7.6 c4.9,0,9.5-0.9,13.7-2.7c4.2-1.8,7.9-4.3,10.9-7.5l5.6,5.6c-3.7,4-8.2,7.2-13.5,9.4c-5.3,2.2-11,3.3-17.3,3.3 c-7.5,0-14.1-1.6-19.9-4.9c-5.8-3.3-10.4-7.9-13.7-13.8c-3.3-5.9-4.9-12.6-4.9-20.2c0-7.5,1.6-14.2,4.9-20.1 c3.3-6,7.8-10.6,13.7-13.9c5.8-3.3,12.3-4.9,19.6-4.9C741.9,110.3,751.1,114.2,757.4,121.8z M757.2,144.9c-0.5-8.1-3.2-14.5-8-19.3 c-4.9-4.8-11.2-7.2-19.1-7.2c-7.8,0-14.3,2.4-19.5,7.2c-5.2,4.8-8.2,11.2-9,19.2H757.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M827.3,188l-0.1-13c-3.1,4.5-7,7.9-12,10.1c-4.9,2.2-10.6,3.3-17,3.3c-5.2,0-9.8-1-13.8-3c-4-2-7.1-4.8-9.2-8.3 c-2.2-3.5-3.2-7.5-3.2-12c0-6.7,2.6-12,7.7-15.8c5.2-3.8,12.3-5.8,21.3-5.8h26v-5.9c0-6.1-1.8-10.8-5.5-14.2c-3.6-3.3-9-5-15.9-5 c-8.3,0-16.6,3.1-24.9,9.3l-4.4-6.8c5.2-3.6,10.2-6.3,14.9-8c4.7-1.7,10.1-2.6,16.2-2.6c9.3,0,16.6,2.3,21.7,7 c5.1,4.7,7.7,11.1,7.8,19.4L837,188H827.3z M817.5,175.4c4.8-3.2,8-7.7,9.7-13.5v-10.6h-24.9c-6.8,0-12,1.1-15.5,3.4 c-3.5,2.3-5.3,5.7-5.3,10.2c0,4.6,1.7,8.3,5.1,11.1c3.4,2.8,7.9,4.2,13.5,4.2C806.9,180.2,812.7,178.6,817.5,175.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.2,90.3h9.9V188h-9.9V90.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M924.7,182.7c-5.3,3.6-11,5.6-17.1,5.8c-5.9,0-10.6-1.8-14-5.5c-3.4-3.6-5.2-9.1-5.2-16.4v-46.1h-11.1l-0.1-7.7 h11.2V90.3h9.9v22.6l25.1-0.1v7.8h-25.1V165c0,9.5,3.5,14.3,10.6,14.3c3.9,0,8.2-1.4,12.8-4.1L924.7,182.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M996.7,118.4c5.3,5.4,7.9,12.7,7.9,22.1V188h-10v-45.2c0-7.3-2-13-6.1-17.1c-4-4.1-9.6-6.2-16.8-6.2 c-8.6,0.1-15.3,2.9-20.1,8.5c-4.9,5.6-7.3,12.9-7.3,22.1V188h-9.9V90.3h9.9v38.7c5.2-12.2,15.4-18.4,30.7-18.6 C984.2,110.3,991.4,113,996.7,118.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.3,143.2c-2.3,5.9-4,12.1-5.1,18.4H80.6c-3.4,0-6.1-2.7-6.1-6.1v-42.7c0-3.4,2.7-6.1,6.1-6.1h36.2 c0.4,0,0.6-0.3,0.6-0.6V69.7c0-3.4,2.7-6.1,6.1-6.1h42.7c3.4,0,6.1,2.7,6.1,6.1V106c0,0.1,0,0.2,0.1,0.3c-0.4,0-0.8,0.1-1.2,0.1 c-5.9,0.5-12.9,1.2-19.7,3c-1.2,0.3-2.8,0.7-4.3,1.3c-4.7,1.6-8.7,3.6-12.2,6.1c-3.7,2.5-6.9,5.5-9.5,9 C121.2,131.5,118.3,138,116.3,143.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.4,172.8c3.7-0.5,7-1.3,10-2.3v27.4c0,3.4-2.7,6.1-6.1,6.1h-42.7c-2.6,0-4.8-1.6-5.7-3.8 c0.7-0.1,1.5-0.3,2.2-0.7c2.3-1.3,3.5-3.9,2.8-6.5c-1.3-5.2-1.2-11.4,0.2-17.7c1.1,1.6,2.9,2.6,5,2.7c1.1,0,2.3-0.2,3.5-0.6 c6-2.2,12.8-2.8,19.9-3.4C155.1,173.7,158.8,173.4,162.4,172.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.4,112.7v42.7c0,3.4-2.7,6.1-6.1,6.1h-20.4c7.1-5.7,13-13.3,17.5-22.5c3-6.4,5-13.4,6.9-20.2 c0.7-2.5,1.3-4.8,2.1-7.1C215.4,112,215.4,112.4,215.4,112.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 114.0831,
    y1: 149.5864,
    x2: 212.733,
    y2: 149.5864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.331947e-7,
    style: {
      stopColor: "#1B0C5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F0770"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210.2,103.5c-11.9,6-25.4,6.2-38.5,7.3c-6.5,0.5-12.8,1.2-18.9,2.8c-1.4,0.4-2.7,0.7-4,1.2 c-3.9,1.3-7.7,3.1-11.2,5.6c-3.3,2.3-6.1,5-8.5,8.1c-3.8,4.8-6.4,10.5-8.7,16.3c-4.1,10.7-6.2,22.1-6.4,33.6c0,4.6-0.1,9.5,0.9,14 c0.2,1,0.4,2.3,1.1,3.1c1,1,2.8,0.1,2.5-1.3c-2.6-10.1-0.3-21.7,4.1-31.2c5-10.8,14.3-17,25.4-20.6c3-1,6-1.8,9.1-2.6 c0.1,0,0.1,0,0.1,0c0.6,0,0.9,0.9,0.3,1.2c-3.7,1.5-7.3,3-10.7,4.7c-16.9,8-24.9,27.9-18.6,28.1c0.5,0,1.1-0.1,1.8-0.4 c9.7-3.6,21.1-3.3,31.7-4.8c3.7-0.5,7.4-1.4,10.8-2.6c13.6-5.1,23.6-15.7,29.8-28.7c4.6-9.6,6.7-21.2,10.2-31.4 c0.5-1.3-0.4-2.4-1.5-2.4C210.8,103.3,210.5,103.3,210.2,103.5L210.2,103.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTronLogoWhitePurple);
export default __webpack_public_path__ + "static/media/TronLogoWhitePurple.876fd3a2154f90f3d44f2274aa3867f7.svg";
export { ForwardRef as ReactComponent };